import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_END_POINTS } from "../ApiEndPoints";
import axios from "axios";
import globalFunction from "../../utils/globalFunction";

const initialState = {
  isLoading: false,
  isError: false,
  message: null,
};

const handleUnauthorizedError = (message) => {
  if (
    message === "Unauthorized" ||
    message?.toLowerCase().includes("user not authorized") ||
    message?.toLowerCase().includes("token has expired") ||
    message?.toLowerCase().includes("jwt expire")
  ) {
    globalFunction.logoutFunction();
  }
};

export const instructorUpdateProfileAPI = createAsyncThunk(
  "instructorUpdateProfileAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.instructorProfileUpdate,
        credentials.payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const instructorStatsAPI = createAsyncThunk(
  "instructorStatsAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        API_END_POINTS.instructorStats,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);


export const instructorAddEducationAPI = createAsyncThunk(
  "instructorAddEducationAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.instructorAddEducation,
        credentials.payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const instructorAddExperienceAPI = createAsyncThunk(
  "instructorAddExperienceAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.instructorAddExperience,
        credentials.payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const getAllCoursesAPI = createAsyncThunk(
  "getAllCoursesAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.getAllCourses, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch courses"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const instructorCoursesAPI = createAsyncThunk(
  "instructorCoursesAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.instructorCourses, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch courses"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);
export const instructorUnpublishCourseAPI = createAsyncThunk(
  "instructorUnpublishCourseAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.instructorUnpublishCourse, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch courses"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const instructorDeclineCourseAPI = createAsyncThunk(
  "instructorDeclineCourseAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.instructorDeclineCourse, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch courses"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const instructorDraftCoursesAPI = createAsyncThunk(
  "instructorDraftCoursesAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.instructorDraftCourse, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch courses"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const skipClickAPI = createAsyncThunk(
  "skipClickAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        API_END_POINTS.skipClick,
        { userId: credentials.auth.user_id, role: credentials.auth.role },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.auth.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

// ahsan code
// Fetching instructor students
export const instructorStudentsAPI = createAsyncThunk(
  "instructorStudentsAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.instructorStudents, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch Students"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const instructorDeactivatedStudentsAPI = createAsyncThunk(
  "instructorDeactivatedStudentsAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.instructorDeactivatedStudents, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch deactivated students"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const instructorProfileAPI = createAsyncThunk(
  "instructorProfileAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.instructorProfile, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        handleUnauthorizedError(error?.response?.data?.message);

        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch Profile"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);





export const getPendingApprovalCoursesAPI = createAsyncThunk(
  "getPendingApprovalCoursesAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.pendingApprovalCourses, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Failed to fetch pending approval courses"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const getUnpublishedCoursesRequestsAPI = createAsyncThunk(
  "getUnpublishedCoursesRequests",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.unpublishedCoursesRequests, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch unpublished courses"
      );
    }
  }
);



export const getAllCertificateByInstructorAPI = createAsyncThunk(
  "getAllCertificateByInstructorAPI",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        API_END_POINTS.getAllCertificateByInstructor,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch certificates"
        );
      }
      return rejectWithValue("Something went wrong!");
    }
  }
);

export const instructorApprovedCertificateAPI = createAsyncThunk(
  "certificate/instructorApprovedCertificateAPI",
  async ({ token, certificateId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_END_POINTS.instructorApprovedCertificate}/${certificateId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return { certificateId, data: response.data };
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to approve certificate"
        );
      }
      return rejectWithValue("Something went wrong!");
    }
  }
);

export const instructorRejectCertificateAPI = createAsyncThunk(
  "certificate/instructorRejectCertificateAPI",
  async ({ token, certificateId, reason }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_END_POINTS.instructorRejectCertificate}/${certificateId}`,
        { reason: reason },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { certificateId, data: response.data };
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to reject certificate"
        );
      }
      return rejectWithValue("Something went wrong!");
    }
  }
);

const intructorSlice = createSlice({
  name: "intructor",
  initialState,
  reducers: {}

});

export default intructorSlice.reducer;
